export const LABEL_SPECIFIC_VOLUME = "specificVolume";
export const LABEL_EQUAL_PERCENTAGES = "equalPercentages";
export const LABEL_GROUP = "group";
export const LABEL_INDIVIDUAL = "individual";
export const LABEL_MULTI_USER = "multiUser";
export const LABEL_SPECIFIC_COUNT = "Case Count";
export const LABEL_SPECIFIC_PERCENTAGE = "Percentages";
export const LABEL_INCOMING_CASES = "incomingCases";
export const LABEL_CODED_CASES = "codedCases";
export const LABEL_IMPORTED_DATA = "importedData";
export const LABEL_TYPE_WORK_QUEUE = "queue";
export const LABEL_TYPE_WORK_PROJECT = "project";
export const LABEL_TYPE_WORK_PROJECT_COMPARE = "project_compare";

export const QA_RULE_LEVELS = {
  "case_samples": "1",
  "coder_samples": "0",
  "verification_samples": "2",
  "cqa_samples": "3"
};
